import React from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import Accordion from 'core/components/Accordion';
import {
  ClaimDataForm,
} from 'pages/Dashboard/pages/Billing/types';
import TextAreaWithActions from 'pages/Dashboard/components/TextAreaWithActions';

export default function ClaimNotes() {
  const { control } = useFormContext<ClaimDataForm>();

  return (
    <Accordion
      defaultExpanded
      header="Notes"
      disableGutters
      headerClasses={{
        root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: '!m-0',
      }}
      detailsClasses={{ root: '!p-0' }}
    >
      <Controller
        control={control}
        name="notes"
        render={({ field }) => (
          <TextAreaWithActions
            {...field}
            className="w-full"
            id="notes-area"
            placeholder="Enter notes here"
            containerClassName="!border-none"
          />
        )}
      />
    </Accordion>
  );
}
